<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19uGW5J/cover.jpeg?1684979237842" alt="This image is the cover for the book Best Dragon Son-in-law, Book 4"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Best Dragon Son-in-law, Book 4
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>"The sparrow flew onto a branch and turned into a phoenix. This kid is lucky."</strong> </p><p>The King of the Underground World, after returning to the city, he became the laughingstock of the family. They wanted to see how he would conquer the cold and aloof CEO and regain his former glory …</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        You LiaoDeYu, Lemon Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3f85386c